import type { MonthRollup } from '../../shared/types'
import { formatCents } from '../../shared/money'
import { formatHours2 } from '../../shared/duration'

// The pivot the user builds by hand today: hours by category with rate and
// extended amount, plus a grand total. Always visible beside the grid.
export default function MonthDashboard({ rollup }: { rollup: MonthRollup | null }) {
  if (!rollup) return <div className="text-sm text-slate-400">—</div>
  return (
    <div className="rounded-lg border border-slate-200 bg-white">
      <table className="w-full border-collapse text-sm">
        <thead>
          <tr className="border-b border-slate-200 text-left text-xs font-semibold uppercase tracking-wide text-slate-500">
            <th className="px-3 py-2">Category</th>
            <th className="px-3 py-2 text-right">Hours</th>
            <th className="px-3 py-2 text-right">Rate</th>
            <th className="px-3 py-2 text-right">Amount</th>
          </tr>
        </thead>
        <tbody>
          {rollup.by_category.length === 0 && (
            <tr>
              <td colSpan={4} className="px-3 py-4 text-center text-slate-400">
                No entries this month.
              </td>
            </tr>
          )}
          {rollup.by_category.map((r) => (
            <tr key={r.category_id ?? 'none'} className="border-b border-slate-100">
              <td className="px-3 py-1.5 text-slate-800">{r.category_name}</td>
              <td className="px-3 py-1.5 text-right tabular text-slate-700">{formatHours2(r.minutes)}</td>
              <td className="px-3 py-1.5 text-right tabular text-slate-500">{formatCents(r.rate_cents)}</td>
              <td className="px-3 py-1.5 text-right tabular text-slate-800">{formatCents(r.amount_cents)}</td>
            </tr>
          ))}
        </tbody>
        <tfoot>
          <tr className="border-t border-slate-300 font-semibold">
            <td className="px-3 py-2 text-slate-900">Total</td>
            <td className="px-3 py-2 text-right tabular text-slate-900">{formatHours2(rollup.total_minutes)}</td>
            <td className="px-3 py-2" />
            <td className="px-3 py-2 text-right tabular text-slate-900">
              {formatCents(rollup.total_amount_cents)}
            </td>
          </tr>
        </tfoot>
      </table>
    </div>
  )
}
